import { assert_false } from '@shared/asserts/utils_asserts';
import { FIELD__base } from '../../_base/FIELD__base';

export function DECORATOR__field_not_linked() {
  return function (method_original: Function, context: ClassMethodDecoratorContext) {
    return function (this: FIELD__base, ...args: any[]) {
      assert_false(this.meta.data__is_linked);
      return method_original.apply(this, args);
    };
  };
}
